import React, { Component } from "react";

import { connect } from "react-redux";
import { Modal } from "semantic-ui-react";
import "./loader.css";
class LoaderModal extends Component {
  render() {
    return (
      <div className="LoaderModal">
        <Modal
          basic
          open={this.props.showModal}
          onClose={this.props.handleClose}
          closeOnEscape={false}
          closeOnRootNodeClick={false}
          size="small"
        >
          <Modal.Content>
            <img
              class="loader"
              src={require("./2017-logo-500x500.png")}
              alt=""
              width="120"
              height="120"
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showModal: state.modal === "loading"
  };
}
export default connect(mapStateToProps)(LoaderModal);



// WEBPACK FOOTER //
// ./src/components/shared-components/loadingmodal.js